'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Work;
(function (Work) {
    var MyWork = /** @class */ (function () {
        function MyWork(ajaxing) {
            if (ajaxing === void 0) { ajaxing = false; }
            this.ajaxing = ajaxing;
            var self = this;
            // 管理ページ 実績カテゴリ切り替え（読み込み時）
            if ($('.trigChangeType').length > 0) {
                var val = $('.trigChangeType:checked').val();
                // console.log(val);
                this.changeEditArea(val);
            }
            // 管理ページ 実績カテゴリ切り替え（編集時）
            $('.trigChangeType').change(function () {
                var val = $(this).val();
                self.changeEditArea(val);
            });
            // 公開ページ 実績カテゴリ切り替え
            $('.trigChangeTypeCommon').click(function () {
                var type = $(this).data('type');
                self.changeTypeCommon(type);
            });
            $('.trigChangeWorksPublishing').click(function () {
                var publishing = $(this).attr("data-publishing");
                var worksId = $(this).data('id');
                self.ajaxChangeWorksPublishing(publishing, worksId);
                return false;
            });
        }
        MyWork.prototype.changeTypeCommon = function (type) {
            $('.trigChangeTypeCommon').attr('data-active', 0);
            $('.trigChangeTypeCommon[data-type="' + type + '"]').attr('data-active', 1);
            if (type == 'ALL' || type == '') {
                $('.bulletChangeTypeCommon').show();
            }
            else {
                $('.bulletChangeTypeCommon').hide();
                $('.bulletChangeTypeCommon[data-type="' + type + '"]').show();
            }
        };
        MyWork.prototype.changeEditArea = function (type) {
            $('.bulletChangeType').hide();
            $('.bulletChangeType[data-type="' + type + '"]').show();
        };
        MyWork.prototype.ajaxChangeWorksPublishing = function (publishing, worksId) {
            var self = this;
            self.ajaxing = true;
            var token = $('meta[name="csrf-token"]').attr('content');
            var D = { publishing: publishing, work_id: worksId };
            console.log(D);
            $.ajax({
                headers: { 'X-CSRF-TOKEN': token },
                url: '/ajax/change_works_publishing',
                type: 'post',
                data: D,
                dataType: 'json',
                beforeSend: function () {
                    // 実行中画面
                    $('#ajaxing-waiting').show();
                },
                success: function (data) {
                    console.log(data);
                    if (data.publishing) {
                        $('.bulletChangeWorksPublishing[data-id="' + worksId + '"]').html('<i class="far fa-circle"></i>');
                        $('.trigChangeWorksPublishing[data-id="' + worksId + '"]').attr('data-publishing', data.publishing).html('非公開にする');
                    }
                    else {
                        $('.bulletChangeWorksPublishing[data-id="' + worksId + '"]').html('<i class="fas fa-times"></i>');
                        $('.trigChangeWorksPublishing[data-id="' + worksId + '"]').attr('data-publishing', data.publishing).html('公開する');
                    }
                },
                complete: function () {
                    // 実行中画面を消す
                    $('#ajaxing-waiting').hide();
                    self.ajaxing = false;
                }
            });
        };
        return MyWork;
    }());
    Work.MyWork = MyWork;
})(Work || (Work = {}));
exports.default = Work;
